@if (cloudinaryVideoUrl && mediaType === 'video') {
  <div class="contentful-video">
    <video controls>
      <source type="video/mp4" src="{{ cloudinaryVideoUrl }}" />
      Your browser does not support the video tag.
    </video>
  </div>
}
